module.exports = __webpack_public_path__ + "img/electricity.7c009473.svg";